<template>
  <b-container>
    <div>
      <div v-if="loading" class="player-spinner offset-sm-6">
        <div class="spinner-border" role="status"></div>
        <div class="loading-text">Loading...</div>
      </div>
      <div class="flex-container" v-if="!loading && !isSafari">
        <div v-if="error">{{error}}</div>
        <Producer
          v-else
          v-for="producer in producers"
          v-bind:key="producer.id"
          :producer="producer"
          @feedPlayer="feedPlayer"
        ></Producer>
        <div v-if="producers.length == 0" class="empty-producers-message">
          <h4>No A<span style="color: #e2001a">TV</span> Live streams available at this moment. Please, try it later.</h4>
        </div>
      </div>
      <div v-if="isSafari">
        Safari detected! Please <input type="button" value="enable cookies" v-on:click="enableSafari()">
      </div>
    </div>
    <div>
      <b-button @click="loadProducers" variant="primary">Refresh</b-button>
    </div>
  </b-container>
</template>

<script>
import Producer from "./Producer.vue";
import axios from "axios";

export default {
  name: "ProducersList",
  components: {
    Producer
  },
  props: {
    token: String
  },
  data() {
    return {
      loading: true,
      error: undefined,
      producers: [],
      popup: null,
      isSafari: false
    };
  },
  methods: {
    track () {
      this.$ga.page({
        page: '/producers',
        title: 'Producers List',
        location: window.location.href
      })
    },
    feedPlayer(stream) {
      this.$emit("feedPlayer", stream);
    },
    loadProducers() {
      this.error = undefined;
      this.loading = true;
      axios.defaults.withCredentials = false;
      axios
        .get("api/producers/", {
          headers: { "Access-Token": this.$cookie.get("token") }
        })
        .then(response => {
          this.producers = [];
          for(var responseElem in response.data["_items"]) {
            var elementStreams = response.data["_items"][responseElem].streams.filter(
              stream => stream.is_live
            )
            if(Array.isArray(elementStreams) && elementStreams.length) {
              var producer = response.data["_items"][responseElem]
              producer.streams = producer.streams.filter(
                stream => stream.is_live
              )
              this.producers.push(producer);
            }
          }
          this.loading = false;
        })
        .catch(error => {
          // handle error
          this.error = error;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    enableSafari(){
      var url = 'https://liveclips-stage.tacticalcamera.mediacoach.es/cookie4safari/';
      this.popup = window.open(url,'1437728504397','width=790,height=350,toolbar=0,menubar=0,location=0,status=1,scrollbars=1,resizable=1,left=400,top=220');
      this.$cookie.set("SafariEnabled", true)
      this.isSafari = !this.$cookie.get('SafariEnabled')
    }
  },
  mounted() {
    this.track();
    this.loadProducers();
    // var ua = navigator.userAgent.toLowerCase(); 
    // if (ua.indexOf('safari') != -1) { 
    //   if (ua.indexOf('chrome') > -1) {
    //     this.isSafari = false
    //   } else {
    //     this.isSafari = !this.$cookie.get('SafariEnabled')
    //   }
    // }
  }  
};
</script>

<style scoped>
.flex-container {
  display: flex;
  flex-wrap: wrap;
}
</style>
